// extracted by css-extract-rspack-plugin
export default {"root":"root-wuBTuE","slotTargetVersion":"slotTargetVersion-dGEL0a","svg":"svg-c0Wsdc"};